import { HttpClient, HttpBackend } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigService } from 'src/config/config.service';
import { handleError } from '../../core/services/service.helpers';
import { firstValueFrom, of, catchError, map } from 'rxjs';
import { isEmptyError } from '@modules/core/services/service.helpers';

export enum ROUTING_PROFILE {
    FREE_MODE = 'freeMode',
    DRIVING_TRAFFIC = 'mapbox/driving-traffic',
    DRIVING = 'mapbox/driving',
    WALKING = 'mapbox/walking',
    CYCLING = 'mapbox/cycling'
}

@Injectable({
    providedIn: 'root'
})
export class RoutingService {
    private _configService = inject(ConfigService);
    private readonly _http: HttpClient;

    constructor() {
        const handler = inject(HttpBackend);

        this._http = new HttpClient(handler);
    }

    public async getDirectionsRoute(type: ROUTING_PROFILE, from: number[], to: number[]): Promise<GeoJSON.LineString> {
        const coordsString = `${from[0]},${from[1]};${to[0]},${to[1]}`;
        const token = this._configService.mapboxAccessToken;
        const apiRequest = `https://api.mapbox.com/directions/v5/${type}/${coordsString}.json?access_token=${token}&overview=full&geometries=geojson`;
        
        try {
            return await firstValueFrom(this._http.get(apiRequest, {}).pipe(
                map((response: any) => {
                    // Check if response has routes array
                    if (!response?.routes || !Array.isArray(response.routes) || response.routes.length === 0) {
                        console.warn('No routes found in routing response');
                        return undefined;
                    }
                    return response.routes[0];
                }),
                map((route: any) => {
                    // Check if route has geometry
                    if (!route?.geometry) {
                        console.warn('No geometry found in route');
                        return undefined;
                    }
                    return route.geometry;
                }),
                catchError(error => {
                    handleError(error);
                    return of(undefined);
                })
            ));
        }
        catch (error) {
            if (isEmptyError(error)) {
                return undefined;
            }

            throw error;
        }
    }
}